import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import { updateEditProductDetail } from '../../../actions/products';
import styles from "./display-category.scss";
import CategorySlider from "./category-slider";
 
function DisplayCategory(props) {
    const {productData = {}} = props;
    const [showCatSlider,updateShowCatSlider] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [slideUp, setSlideUp] = useState(false);
    const [formElements, setFormElements] = useState([{
        label: "Display Category",
        key: "productGroupBreadCrumbList",
        holderClass: styles['display-cat-input'],
        input: {
            value: "",
            readOnly: true,
            onClick: (item) => {
                setActiveIndex(0);
                updateShowCatSlider(true);
            }
        },
        rightIconClass: "icon-Next",
        onRightIconClick: () => {
            setActiveIndex(0);
            updateShowCatSlider(true);
        },
    }]);

    const fillCategoryData = (data) => {
        let categoryIds = data?.selectedProductGroupIds && typeof data.selectedProductGroupIds == "string" ? data.selectedProductGroupIds.split(',') : Array.isArray(data.selectedProductGroupIds) ? data.selectedProductGroupIds : [];  
        let dispCategory = [];
        let currentCatList = data?.productGroupBreadCrumbList ? (typeof data?.productGroupBreadCrumbList == "string" ? [data.productGroupBreadCrumbList] : [...data.productGroupBreadCrumbList]) : [];
        currentCatList.map((cur, index) => {
            dispCategory.push({
                label: "Display Category "+(currentCatList.length>1 ? index+1 : ''),
                key: "productGroupBreadCrumbList",
                holderClass: styles['display-cat-input'],
                categoryId: categoryIds[index],
                input: {
                    value: cur,
                    readOnly: true,
                    onClick: (item) => {
                        setActiveIndex(index);
                        updateShowCatSlider(true);
                    }
                },
                rightIconClass: "icon-Next",
                onRightIconClick: () => {
                    setActiveIndex(0);
                    updateShowCatSlider(true);
                }
            });
        })
        let temp = formElements;
        dispCategory.map((cur, index) => {
            temp.splice(index, 1, cur);
        })
        setFormElements(temp);
    }

    const selectCategory = (data) => {
        let existingData = productData?.productGroupBreadCrumbList ? [...productData.productGroupBreadCrumbList] : [];
        let existingPuvIds = productData?.selectedProductGroupIds?.toString() || '';
        if(existingPuvIds){
            let tempCatIds = existingPuvIds.split(',');
            if(activeIndex <= tempCatIds.length){
                tempCatIds[activeIndex] = data.productGroupId.toString();
            }else{
                tempCatIds.push(data.productGroupId.toString());
            }
            existingPuvIds = tempCatIds.join(',');
        }
        if(activeIndex <= existingData.length){
            existingData[activeIndex] = data.productGroupBreadCrumb;
        }else{
            existingData.push(data.productGroupBreadCrumb);
        }

        fillCategoryData({
            productGroupBreadCrumbList: existingData,
            selectedProductGroupIds: existingPuvIds ? existingPuvIds : data.productGroupId.toString(),
            productGroup: existingPuvIds ? existingPuvIds : data.productGroupId.toString()
        });

        props.updateEditProductDetail([{
            key: 'productGroupBreadCrumbList',
            value: existingData
        },
        {
            key: 'selectedProductGroupIds',
            value: existingPuvIds ? existingPuvIds : data.productGroupId.toString(),
        },
        {
            key: 'productGroup',
            value: existingPuvIds ? existingPuvIds : data.productGroupId.toString()
        }]);
    }

    const closeCatSlider = () => {
        updateShowCatSlider(false);
    }

    const addAnotherCat = () => {
        if (formElements.length < 5) {
            let newFormElement = JSON.parse(JSON.stringify(formElements[0]));
            newFormElement.categoryId = null;
            newFormElement.input.onClick = () => {
                setActiveIndex(formElements.length);
                updateShowCatSlider(true);
            }
            newFormElement.onRightIconClick = () => {
                setActiveIndex(formElements.length);
                updateShowCatSlider(true);   
            }
            formElements[0].label = 'Display Category 1';
            newFormElement.label = 'Display Category ' + (formElements.length + 1)
            newFormElement.input.value = '';
            let newFormElements = formElements.concat([newFormElement]);
            for (let i = 0; i < newFormElements.length; i++) {
                newFormElements[i].label = 'Display Category' + ((i == 0 && newFormElements.length == 1) ? '': ' ' + (i+1) );
            }
            setFormElements(newFormElements);
        }
    }

    const removeCat = (index) => {
        let newFormElements = [...formElements], timeout = 300;
        if(index === 0 && newFormElements.length == 1){
            newFormElements[0].input.value = '';
            newFormElements[0].categoryId = '';
            timeout = 1;
        }else{
            newFormElements.splice(index, 1);
            for (let i = 0; i < newFormElements.length; i++) {
                newFormElements[i].label = 'Display Category' + ((i == 0 && newFormElements.length == 1) ? '': ' ' + (i+1) );
                newFormElements[i].input.onClick = () => {
                    setActiveIndex(i);
                    updateShowCatSlider(true);
                }
            }
            setSlideUp(true);
        }
        setTimeout(() => {
            setFormElements(newFormElements);
            setSlideUp(false);
        }, timeout);

        let existingData = productData?.productGroupBreadCrumbList ? [...productData.productGroupBreadCrumbList] : [];
        existingData.splice(index, 1);
        let selectedGroupIds = productData?.selectedProductGroupIds || 0;
        if(typeof(selectedGroupIds) != 'number'){
            selectedGroupIds = selectedGroupIds.split(',');
            selectedGroupIds.splice(index, 1);
        }
        props.updateEditProductDetail([{
            key: 'productGroupBreadCrumbList',
            value: existingData
        },
        {
            key: 'selectedProductGroupIds',
            value: (typeof(selectedGroupIds) != 'number') ? selectedGroupIds.join(',') : 0
        },
        {
            key: 'productGroup',
            value: (typeof(selectedGroupIds) != 'number') ? selectedGroupIds.join(',') : 0
        }]);
    }

    useEffect(() => {
        if(productData?.productGroupBreadCrumbList){
            fillCategoryData(productData);
        }
    }, [productData.productGroupBreadCrumbList]);

    return (
        <>
            <div className={`${styles['add-category-container']} ${slideUp ? styles['slide-up']:''} ${formElements.length == 5 ? styles['no-btn']: ''}`}>
                {
                    formElements.map((cur, index) => {
                        return <div className={styles['dropdown-icon-holder']}>
                            <InputWithMovingLabel
                                {...cur}
                                errorMessage={index == 0 ? props.errors.displayCat : ''}
                            />
                            {(formElements[0].input.value || formElements.length > 1) ? <span className={`'icon-trash' ${styles['icon-trash']}`} onClick={() => removeCat(index)}></span> : null}
                        </div>
                    })
                }
                <div
                    className={styles['add-another-btn']}
                    variant="text"
                    style={formElements.length < 5 ?{}: {display:'none'}}
                    onClick={addAnotherCat}>
                    <i className='icon-plus'></i>
                    <span>Add Another Display Category</span>
            </div>
        </div>
        {showCatSlider ? <CategorySlider closeCatSlider = {closeCatSlider} selectCategory = {selectCategory} selectedCatId={formElements[activeIndex].categoryId}/> : null}
        </>
    )
}

const mapStateToProps = state => {
    return {
        session: state.session,
        deviceData: state.deviceData,
        errors: state.items.errors
    };
};

export default connect(mapStateToProps, {
    updateEditProductDetail
})(DisplayCategory);
